import { render } from "./loaderPage.vue?vue&type=template&id=76134f7f&scoped=true"
import script from "./loaderPage.vue?vue&type=script&lang=js"
export * from "./loaderPage.vue?vue&type=script&lang=js"

import "./loaderPage.vue?vue&type=style&index=0&id=76134f7f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76134f7f"]])

export default __exports__